<template>
  <div />
</template>

<script>
  import { mapGetters } from "vuex"

  export default {
    props: {
      googleAnalyticsId: {
        type: String,
        default: ""
      },
      ga4Id: {
        type: String,
        default: ""
      }
    },
    computed: {
      ...mapGetters(["user"])
    },
    watch: {
      "$route": "SendPageView"
    },
    created () {
      let gaScriptTag = document.createElement("script")
      gaScriptTag.innerText = "var _gaq = _gaq || [];"
      gaScriptTag.innerText += "(function() {"
      gaScriptTag.innerText += "    var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;"
      gaScriptTag.innerText += "    ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';"
      gaScriptTag.innerText += "    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);"
      gaScriptTag.innerText += "})();"
      document.head.appendChild(gaScriptTag)

      this.setupGA4Tag();
    },
    mounted () {
      this.SendPageView()
    },
    methods: {
      SendPageView () {
        _gaq.push(["_setAccount", this.googleAnalyticsId])
        _gaq.push(["_setSessionCookieTimeout", 14400000])
        _gaq.push(["_setCustomVar", 1, "AUID", this.user.UserId, 1])
        _gaq.push(["_setCustomVar", 2, "DealerCode", this.user.DealerCode, 3])
        _gaq.push(["_setCustomVar", 3, "JobClass", this.user.JobClass.Type + "-" + this.user.JobClass.Name.replace(" ", ""), 2])
        _gaq.push(["_setCustomVar", 5, "Language", this.user.LanguagePreference.Code, 2])
        _gaq.push(["_setSiteSpeedSampleRate", 50])
        var pluginUrl = "//www.google-analytics.com/plugins/ga/inpage_linkid.js"
        _gaq.push(["_require", "inpage_linkid", pluginUrl])
        _gaq.push(["_trackPageview"])
      },
      
      setupGA4Tag(){
        let ga4ScriptTag = document.createElement("script")
        ga4ScriptTag.src = "https://www.googletagmanager.com/gtag/js?id=" + this.ga4Id;
        document.head.appendChild(ga4ScriptTag)

        let ga4ScriptTag2 = document.createElement("script")
        ga4ScriptTag2.innerText = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '"
          + this.ga4Id
          + "', {'AUID': '" +  this.user.UserId + "',"
          + "'DealerCode': '" + this.user.DealerCode + "',"
          + "'JobClass': '" + this.user.JobClass.Type + "-" + this.user.JobClass.Name.replace(" ", "") + "',"
          + "'Language_Preference': '" + this.user.LanguagePreference.Code + "'"
          + "});";
        document.head.appendChild(ga4ScriptTag2) ;
      }
    },
  }

</script>
